const axios = require('axios');


export function queryVisits(query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'report/visitor?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Visitor List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js